import React from 'react';
import ReactDOM from 'react-dom';
import '../styles/OnboardingRoleSelector.css';

const OnboardingRoleSelector = ({ isOpen, onClose, onSelectRole }) => {
  if (!isOpen) return null;

  const roles = [
    {
      id: 'admin',
      title: 'Admin',
      description: 'View the Admin onboarding experience'
    },
    {
      id: 'operator',
      title: 'Operator',
      description: 'View the Operator onboarding experience'
    },
    {
      id: 'client',
      title: 'Client',
      description: 'View the Client onboarding experience'
    }
  ];

  const handleRoleClick = (roleId) => {
    onSelectRole(roleId);
    onClose();
  };

  return ReactDOM.createPortal(
    <div className="onboarding-role-selector-overlay" onClick={onClose}>
      <div className="onboarding-role-selector-modal" onClick={(e) => e.stopPropagation()}>
        <div className="onboarding-role-selector-header">
          <h2>Select Onboarding Experience</h2>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close" />
        </div>

        <div className="onboarding-role-selector-content">
          <p className="onboarding-role-selector-description">
            Choose which role's onboarding tour you'd like to preview.
          </p>

          <div className="onboarding-role-cards">
            {roles.map((role) => (
              <div
                key={role.id}
                className="onboarding-role-card"
                onClick={() => handleRoleClick(role.id)}
              >
                <h3 className="onboarding-role-card-title">{role.title}</h3>
                <p className="onboarding-role-card-description">{role.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default OnboardingRoleSelector;
